import React from "react";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";

const WhyJoinUs = () => {
  const features = [
    {
      icon: "✔️",
      title: "Expert Faculty",
      description: "Learn from highly qualified and experienced teachers dedicated to your success.",
    },
    {
      icon: "⭐",
      title: "Proven Track Record",
      description: "Thousands of students have excelled in their careers with our guidance.",
    },
    {
      icon: "🏆",
      title: "State-of-the-Art Facilities",
      description: "Modern classrooms, digital resources, and top-notch infrastructure.",
    },
    {
      icon: "📚",
      title: "Comprehensive Study Materials",
      description: "Get well-structured notes, books, and online resources for in-depth learning.",
    },
  ];

  return (
    <div className="container my-5">
      <motion.h1
        className="text-center mb-4 fw-bold"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Why Join Prakash Institute?
      </motion.h1>

      <div className="row g-4">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="col-md-6 col-lg-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
          >
            <Tilt tiltMaxAngleX={15} tiltMaxAngleY={15} glareEnable={true} glareMaxOpacity={0.3} scale={1.05}>
              <div className="card text-center p-4 shadow-lg rounded-4 border-0">
                <div className="fs-1">{feature.icon}</div>
                <h3 className="h5 mt-3">{feature.title}</h3>
                <p className="text-muted">{feature.description}</p>
              </div>
            </Tilt>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WhyJoinUs;
